import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OssDataTable = _resolveComponent("OssDataTable")!

  return (_openBlock(), _createBlock(_component_OssDataTable, {
    items: _ctx.userActivitiesHistory,
    headers: _ctx.dataHeader,
    "fixed-header": "",
    "fixed-footer": true,
    "item-key": "index",
    "display-row-number": true,
    loading: _ctx.loading,
    class: "v-data-table--striped v-data-table--dense"
  }, {
    [`item.date`]: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_ctx.formatTime(item.date)), 1)
    ]),
    [`item.action`]: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_ctx.getActionTitle(item)), 1)
    ]),
    [`item.company`]: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_ctx.fctName(item)), 1)
    ]),
    [`item.user`]: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_ctx.getUserDisplayName(item.user)), 1)
    ]),
    [`item.userBT`]: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_ctx.getUserDisplayName(item.user)), 1)
    ]),
    [`item.accountType`]: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_ctx.getAccountType(item.account.type)), 1)
    ]),
    [`item.import`]: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_ctx.fctImport(item)), 1)
    ]),
    _: 2
  }, 1032, ["items", "headers", "loading"]))
}